"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7518],{

/***/ 57518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95197);



function ContentfulButton(props) {
    var rounded = props.rounded, size = props.size, url = props.url, target = props.target, id = props.id, cta = props.cta;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        textAlign: "center",
        py: 2,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
            rounded: rounded,
            size: size,
            href: url,
            target: target,
            id: id,
            children: cta
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (ContentfulButton);


/***/ })

}]);